import { useLang, useLangNavigate, useT } from '@/i18n';
import { motion } from 'framer-motion';
import { BarChart3, BookOpen, Home, User } from 'lucide-react';
import { useLocation } from 'react-router-dom';

/* Подписи хранятся ключами, а не текстом: иначе при смене языка пришлось бы
 * пересобирать этот массив, и он бы кешировался вместе со старым языком. */
const navItems = [
  { path: '/home', icon: Home, labelKey: 'ui.nav.home' },
  { path: '/modules', icon: BookOpen, labelKey: 'ui.nav.modules' },
  { path: '/progress', icon: BarChart3, labelKey: 'ui.nav.progress' },
  { path: '/profile', icon: User, labelKey: 'ui.nav.profile' },
];

export const BottomNavigation = () => {
  const navigate = useLangNavigate();
  const location = useLocation();
  const lang = useLang();
  const t = useT();

  return (
    <nav className="sticky bottom-0 left-0 right-0 bg-card shadow-bottom-nav border-t border-border z-50">
      <div className="flex items-center justify-around px-2 py-2 pb-safe-bottom">
        {navItems.map((item) => {
          // в адресе лежит язык, поэтому сравниваем с префиксом, а не с голым путём
          const isActive = location.pathname === `/${lang}${item.path}`;
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg relative"
            >
              {isActive && (
                <motion.div
                  layoutId="nav-indicator"
                  className="absolute inset-0 bg-primary/8 rounded-lg"
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <Icon
                size={22}
                className={`relative z-10 transition-colors duration-200 ${isActive ? 'text-primary' : 'text-muted-foreground'
                  }`}
                strokeWidth={isActive ? 2.5 : 1.8}
              />
              <span
                className={`text-[10px] font-medium relative z-10 transition-colors duration-200 ${isActive ? 'text-primary' : 'text-muted-foreground'
                  }`}
              >
                {t(item.labelKey)}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
